export default "__VITE_ASSET__8dnkTrxp__"